export enum Icons {
  Email = 'FaEnvelope',
  Download = 'FaCloudDownloadAlt',
  PaperPlane = 'FaPaperPlane',
}
